import { Box, Center, Flex, Grid, Heading, Text } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { AiFillLinkedin } from "react-icons/ai";
import { AiFillGithub } from "react-icons/ai";
import { AiFillInstagram } from "react-icons/ai";
import { FaReact } from "react-icons/fa";
import { FaNodeJs } from "react-icons/fa";
import { SiExpress } from "react-icons/si";
import { SiMongodb } from "react-icons/si";

import { ThemeContext } from './context/ThemeProvider'
import { Link } from 'react-router-dom'




const About = () => {
   const {theme}=useContext(ThemeContext)
  
  return (
    <Center h={{xl:'70vh',md:'40vh',base:'70vh'}} id='about'  className="about section" >

    
    <Box  w='60%' style={theme?{color:'black'}:{color:'white'}}  >
       <Heading color={'rgb(4, 80, 52)'} >
      About Me
     </Heading>
     <Box fontSize={{xl:"1.4rem",lg:"1.4rem",md:"1.4rem",sm:'1.2rem'}} textAlign="left" >
      <Box  id="user-detail-intro" mt={5} textAlign="justify">
      A Full Stack Web Developer with a strong foundation in modern web development technologies. I recently completed a brief but intensive period of Prompt Engineering, where I delved into Python and Angular. I am now skilled in building scalable and responsive web applications using React, Redux, Express.js, and MongoDB. Passionate about creating efficient and user-friendly interfaces while ensuring optimal performance and maintainability.
    </Box>
    </Box>
    <Flex className="link" justify={'space-between'} mt={5}  display={{xl:'flex',base:'none'}}>
<Box textAlign={'left'} fontWeight={'bold'}>
    <Text>FIND ME IN</Text>
    <Grid templateColumns={{xl:'repeat(3,1fr)',lg:'repeat(3,1fr)',base:'repeat(1,1fr)'}} fontSize={40}  gap={5}>
    <Link  id="contact-linkedin" to='https://www.linkedin.com/in/mohd-asim-8688061b2/'> <AiFillLinkedin color='blue'/>  </Link>
    <Link id="contact-github" to='https://github.com/Asimji'><AiFillGithub color='gray'/></Link>
    <Link><AiFillInstagram color='#8730bc'/></Link>
    </Grid>
    </Box>       
<Box  textAlign={'left'} fontWeight={'bold'}>
<Text>BEST SKILL ON</Text>
    <Grid templateColumns='repeat(4,1fr)'  fontSize={40} gap={5}>
        <Link><FaReact color='blue'/></Link>
        <Link><FaNodeJs color='green'/></Link>
        <Link><SiExpress color='gray'/></Link>
        <Link><SiMongodb color='green'/></Link>
    </Grid>
    </Box>       

            </Flex>
    </Box>
    </Center>
  )
}

export default About
